"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var R = _interopRequireWildcard(require("ramda"));
var _omit = _interopRequireDefault(require("../run/omit"));
var _height = _interopRequireDefault(require("../attributedString/height"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var ATTACHMENT_CODE = "\uFFFC"; // 65532

/**
 * Remove attachment attribute if no char present
 *
 * @param  {Object} attributed string
 * @return {Object} attributed string
 */
var purgeAttachments = R.when(R.compose(R.not, R.includes(ATTACHMENT_CODE), R.prop('string')), R.evolve({
  runs: R.map((0, _omit.default)('attachment'))
}));

/**
 * Layout paragraphs inside rectangle
 *
 * @param  {Object} rect
 * @param  {Array} attributed strings
 * @return {Object} layout blocks
 */
var layoutLines = function layoutLines(rect, lines, widths, offsets) {
  var currentY = rect.y;
  return R.addIndex(R.map)(R.compose(purgeAttachments, function (line, i) {
    var style = R.pathOr({}, ['runs', 0, 'attributes'], line);
    var height = Math.max((0, _height.default)(line), style.lineHeight);
    var box = {
      x: rect.x + (i < offsets.length ? offsets[i] : offsets[offsets.length - 1]),
      y: currentY,
      width: i < widths.length ? widths[i] : widths[widths.length - 1],
      height: height
    };
    currentY += height;
    return R.compose(R.assoc('box', box), R.omit(['syllables']))(line);
  }))(lines);
};
var computeOffsetsAndWidths = function computeOffsetsAndWidths(containerRect, maskRects, lineHeight) {
  var results = [];
  var maskIndex = 0;
  var lineIndex = 0;
  while (maskIndex < maskRects.length) {
    while ((lineIndex + 1) * lineHeight + containerRect.y < maskRects[maskIndex].y) {
      results.push({
        offset: 0,
        width: containerRect.width
      });
      lineIndex += 1;
    }
    while (maskRects[maskIndex].y + maskRects[maskIndex].height >= lineIndex * lineHeight + containerRect.y) {
      // colliding region with mask
      var widthToRight = Math.min(containerRect.width - (maskRects[maskIndex].width - (containerRect.x - maskRects[maskIndex].x)));
      var widthToLeft = Math.min(maskRects[maskIndex].x - containerRect.x, containerRect.width);
      if (widthToLeft >= widthToRight) {
        results.push({
          offset: 0,
          width: widthToLeft
        });
      } else {
        results.push({
          offset: containerRect.width - widthToRight,
          width: widthToRight
        });
      }
      lineIndex += 1;
    }
    maskIndex += 1;
  }
  results.push({
    offset: 0,
    width: containerRect.width
  });
  return results;
};

/**
 * Performs line breaking and layout
 *
 * @param  {Object} engines
 * @param  {Object}  layout options
 * @param  {Object} rect
 * @param  {Object} attributed string
 * @return {Object} layout block
 */
var layoutParagraph = function layoutParagraph(engines, options) {
  return function (rect, paragraph) {
    var indent = R.pathOr(0, ['runs', 0, 'attributes', 'indent'], paragraph);
    var lineHeight = (0, _height.default)(paragraph);
    var offsetsAndWidths = computeOffsetsAndWidths(rect, options.maskRects || [], lineHeight);

    // duplicating the last line width to avoid applying identations to all the lines
    var extendedOffsetsAndWidths = [].concat(offsetsAndWidths, [offsetsAndWidths[offsetsAndWidths.length - 1]]);
    var widths = extendedOffsetsAndWidths.map(function (item, index) {
      if (index === 0) {
        return item.width - indent;
      }
      return item.width;
    });
    var offsets = extendedOffsetsAndWidths.map(function (item, index) {
      if (index === 0) {
        return item.offset + indent;
      }
      return item.offset;
    });
    var lines = engines.linebreaker(options)(paragraph, widths);
    var lineFragments = layoutLines(rect, lines, widths, offsets);
    return lineFragments;
  };
};
var _default = exports.default = layoutParagraph;